import { useContext, useState } from 'react';
import { checkType } from '../../../Utils/Helpers';
import UsersList from './UsersList';
import { CompetitionRegisterContext } from '../../../Context/CompetitionRegisterContext';
import CoachList from './CoachList';
import TeamList from './TeamList';
import LeagueList from './LeagueList';
import SupervisorList from './SupervisorList';

const Step3 = ({ error, success, navigate, get, setActiveNextLevel }) => {
  const context = useContext(CompetitionRegisterContext);
  const [loading, setLoading] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  return (
    <div className='row'>
      <div className='col-12'>
        <div className='d-flex flex-column'>
          <p className='text-dark f-14 font-weight-bold text-left my-3 line-height-3'>
            لطفا تمامی اطلاعات خود را با دقت بررسی کنید و در صورت صحیح نبودن هر
            کدام از اطلاعات با برگشتن به مراحل قبلی اطلاعات خود را اصلاح و سپس
            بر روی گزینه ثبت و تایید نهایی کلیک کنید.
          </p>
        </div>
      </div>
      {checkType(context, 'انفرادی') && <UsersList context={context} />}
      {checkType(context, 'تیمی') && <TeamList context={context} />}
      {checkType(context, 'لیگ') && <LeagueList context={context} />}
      {<CoachList context={context} />}
      {<SupervisorList context={context} />}
      <div className='d-flex flex-row justify-content-center w-100 my-3'>
        <div className='form-group w-30 mx-auto'>
          <label className='text-dark f-14 my-2'>استان</label>
          <select
            className='form-control w-100'
            onChange={(e) => {
              context.province_id = e.target.value;
            }}
          >
            <option disabled={true} selected={true}>
              انتخاب استان
            </option>
            {context.competition?.provinces?.map((province) => (
              <option value={province?.id}>{province?.name}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Step3;
